module.exports = __webpack_public_path__ + "media/images/lp/img_guide-4e4a17f0a7d5c3ff3a53fbd572b74b12.png";